import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
/* istanbul ignore file */
import { Processors } from '../../../constants/AppConstants';
var AdyenService = /*#__PURE__*/function () {
  // @TODO CW-1870 replace with Adyen Client object type from @adyen/adyen-web

  function AdyenService(params) {
    _classCallCheck(this, AdyenService);
    _defineProperty(this, "type", Processors.ADYEN);
    _defineProperty(this, "dispatch", void 0);
    _defineProperty(this, "clientInstance", null);
    this.dispatch = params.dispatch;
    this.initialize(params);
  }
  return _createClass(AdyenService, [{
    key: "initialize",
    value: function initialize(_) {
      if (this.clientInstance) return;

      // @TODO CW-1870 create Adyen client via AdyenCheckout from @adyen/adyen-web
    }
  }]);
}();
export { AdyenService as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/business/processors/adyen/AdyenService.js
// module id = 4603
// module chunks = 11